import React from 'react';
import { Badge } from './ui/badge';
import { Zap, Clock, Languages, Database } from 'lucide-react';
import { mockData } from '../data/mock';

const StatsSection = () => {
  const { stats, partners } = mockData;

  const statItems = [
    {
      icon: Database,
      value: stats.gamesIntegrated,
      label: 'Games Integrated',
      color: 'text-blue-600'
    },
    {
      icon: Zap,
      value: stats.eventsPerMonth,
      label: 'Events per Month',
      color: 'text-green-600'
    },
    {
      icon: Clock,
      value: stats.averageLatency,
      label: 'Average Latency',
      color: 'text-orange-600'
    },
    {
      icon: Languages,
      value: stats.languages,
      label: 'Languages Supported',
      color: 'text-purple-600'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Stats Grid */}
        <div className="mb-16">
          <div className="text-center mb-12">
            <Badge variant="outline" className="mb-4">
              Platform Statistics
            </Badge>
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Powering the next generation of gaming
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Our platform processes millions of events and serves thousands of games across 
              global markets with industry-leading performance.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 max-w-4xl mx-auto">
            {statItems.map((item, index) => {
              const IconComponent = item.icon;
              return (
                <div key={index} className="text-center group">
                  <div className="mb-4 mx-auto w-16 h-16 bg-white rounded-2xl shadow-sm flex items-center justify-center group-hover:shadow-md transition-shadow">
                    <IconComponent className={`w-8 h-8 ${item.color}`} />
                  </div>
                  <div className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
                    {item.value}
                  </div>
                  <div className="text-sm font-medium text-gray-600">
                    {item.label}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Partner Logos */}
        <div className="text-center">
          <h3 className="text-lg font-semibold text-gray-900 mb-8">
            Trusted by industry leaders
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center justify-items-center opacity-60 hover:opacity-80 transition-opacity">
            {partners.map((partner, index) => (
              <div key={index} className="grayscale hover:grayscale-0 transition-all duration-300">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-12 w-auto max-w-[120px] object-contain"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;